import { LINE_LAYER_TYPE, SHAPE_LAYER_TYPE } from "../../Designer/constants.ts";
import { useSelectedLayerType } from "../../Designer/hooks/useSelectedLayerType.ts";
import { EditLineSettingsControls } from "./EditLineSettingsControls.tsx";
import { EditShapeSettingsControls } from "./EditShapeSettingsControls.tsx";
import { ShapeEmptyState } from "./ShapeEmptyState.tsx";

export const EditShapeSettings = () => {
  const selectedLayerType = useSelectedLayerType();

  switch (selectedLayerType) {
    case SHAPE_LAYER_TYPE:
      return <EditShapeSettingsControls />;
    case LINE_LAYER_TYPE:
      return <EditLineSettingsControls />;
    default:
      return <ShapeEmptyState />;
  }
};
